export class Pais {
    id: string = "1";
    descripcion: string = "";

}
